import React from "react";
import { Course } from "../model/course";
import { ProgramProgress, UserProgress } from "../model/progress";
import { TableRow, TableCell, IconButton, Box, Collapse, Table, TableBody, TableHead } from "@mui/material";

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import LinearWithValueLabel from "./linearprogress";
import { Program } from "../model/program";
import { RootState } from "../reducers/store";
import { useSelector } from 'react-redux';
import { User } from "../model/user";

export const UserProgressCourseRow = (props: { userProgress: UserProgress, currentProgram: Program | null, currentCourses: Course[]}) => {
    const { userProgress, currentProgram, currentCourses } = props;
    const [open, setOpen] = React.useState(false);

    const allUsers: User[] = useSelector((state: RootState) => state.users.users);
    const userRow: User | undefined = allUsers.find((user) => user.id == userProgress.userId)

    let currentProgramProgress: ProgramProgress | undefined = userProgress.progress.programs.find((program) => program.id == currentProgram?.id)

    return(
        <React.Fragment>
            <TableRow key={currentProgram?.id}>
                <TableCell width={60}>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon/>: <KeyboardArrowDownIcon/>}
                    </IconButton>
                </TableCell>
                <TableCell width={300}>{LinearWithValueLabel(currentProgramProgress?.progressPercentage ?? 0)}</TableCell>
                <TableCell>{userRow?.email ?? ""}</TableCell>
            </TableRow>

            <TableRow>
                <TableCell style={{ padding: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box sx={{ margin: 1 }}>
                        <Table size="small" aria-label="assessmentInfo">
                        <TableHead>
                            <TableRow>
                                <TableCell />
                                <TableCell></TableCell>
                                <TableCell>Chapter</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                currentCourses?.map(course => {
                                    let matchingCourseProgress = currentProgramProgress?.courses.find(progress => progress.id == course.uuid)
                                    let percentage = matchingCourseProgress?.progressPercentage

                                    if (matchingCourseProgress && percentage) {
                                        return(
                                            <TableRow key={course.name}>
                                                <TableCell width={60}/>
                                                <TableCell width={300}>{LinearWithValueLabel(percentage)}</TableCell>
                                                <TableCell>{course.name}</TableCell>
                                            </TableRow>
                                        )
                                    } else {
                                        return(
                                            <TableRow key={course.name}>
                                                <TableCell width={60}/>
                                                <TableCell width={300}>{LinearWithValueLabel(0)}</TableCell>
                                                <TableCell>{course.name}</TableCell>
                                            </TableRow>
                                        )
                                    }
                                })
                            }
                        </TableBody>
                        </Table>
                    </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
}